export class CalidadProducto {
    resultadoPurga: string;
    numeroPruebaAbreviada: string;
    numeroCertificadoAnalisis: string;
    aptoCalidad: boolean;
    temperatura: number;
    densidad: number;
    conductividad: number;
    diferenciaDensidad: number;
}